export default "__VITE_ASSET__CBdpzuLx__"